import { EventEmitter, Inject, Injectable, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable, of, timer } from 'rxjs';
import { catchError, finalize, shareReplay, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { AlertController, IonicSafeString, ModalController, ToastController } from '@ionic/angular';
import { onSimrLoginPrimaryUser } from '../utils/simr-role-selection';

/** Keeps a failed token refresh from raising its own banner. Not an HTTP header. */
export const SILENT_HTTP_ERROR = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // getGroupedCampaigns() {
  //   throw new Error('Method not implemented.');
  // }
  environment: any = environment;
  matrix_url = '';
  portal_url = environment.portal_url;
  portal_upload_url = environment.portal_upload_url;
  // portal_url='https://pulse.tips.in';
  // portal_upload_url='https://pulse-upload.tips.in';
  // portal_url='http://
  access_token = '';
  is_autologout = false;
  current_user: any = {};
  public currentUser$ = new BehaviorSubject<any>(null);
  public show_sidebar_menu = true;
  public currentPermissions: any = {};
  public currentRole: any = {};
  // private selectedActivity: any;

  constructor(private http: HttpClient, public alertController: AlertController, public toastController: ToastController, public modalController: ModalController) { }

  /**
   * Role-wise permission change: capability flags for the logged-in session are taken from
   * the expanded `role` object on `/users/me` (Directus roles collection), not from columns on `directus_users`.
   */
  syncRoleDerivedStateFromCurrentUser(user: any): void {
    const role = user?.role && typeof user.role === 'object' ? user.role : {};
    // this.currentRole = user || {};
    // this.currentPermissions = user || {};
    this.currentRole = role;
    this.currentPermissions = { ...role };
    const roleName = String(role?.name || '').trim().toLowerCase();
    const isSuperByName = roleName === 'super admin' || roleName === 'superadmin' || roleName === 'administrator';
    this.currentPermissions.is_super_admin = !!(role?.is_super_admin ?? role?.super_admin ?? isSuperByName);
    // TIPS Video Library — mirror role flags; elevated roles get full video access.
    const elevated = this.currentPermissions.is_super_admin;
    this.currentPermissions.tips_video_addedit = elevated || !!role?.tips_video_addedit;
    this.currentPermissions.tips_video_inherited_addedit = elevated || !!role?.tips_video_inherited_addedit;
    this.currentPermissions.edit_published_video_isrc_entry = elevated || !!role?.edit_published_video_isrc_entry;
    // DB field may be `is_onhold_access` on roles; templates historically used `is_onhold_acess`
    if (this.currentPermissions.is_onhold_access != null && this.currentPermissions.is_onhold_acess == null) {
      this.currentPermissions.is_onhold_acess = !!this.currentPermissions.is_onhold_access;
    }
  }

  public async get(
    collectionORendpoint: string,
    params: any = {},
    useCache: boolean = false,
    is_public = false,
    is_direct = false,
    is_matrix = false, session: any = {}
  ) {
    const suppressErrorToast = params?.suppressErrorToast === true;
    if (suppressErrorToast) {
      params = { ...params };
      delete params.suppressErrorToast;
    }
    //if(is_matrix && session.access_token){
    //  params.access_token=session.access_token;
    //}
    //console.log('Requestng Cahe',useCache);
    let urlendpoint = collectionORendpoint;
    if (is_direct) {
      urlendpoint = collectionORendpoint;
    } else if (is_matrix) {
      urlendpoint = this.matrix_url + '/' + collectionORendpoint;
    }
    else if (collectionORendpoint.includes('/')) {
      urlendpoint = this.portal_url + '/' + collectionORendpoint;
      // Normalize double slashes but preserve https:// or http://
      urlendpoint = urlendpoint.replace(/([^:])\/\//g, '$1/');
    } else {
      urlendpoint = this.portal_url + '/items/' + collectionORendpoint;
      // Normalize accidental double slashes in base URL
      urlendpoint = urlendpoint.replace(/([^:])\/\//g, '$1/');
      if (!is_public) {
        params.filter = {
          ...params.filter,

        };


      }
    }




    //    console.log('urlendpoint', urlendpoint);
    if (params.filter) {
      // Avoid double-encoding when caller already sent a JSON string
      params.filter = typeof params.filter === 'string' ? params.filter : JSON.stringify(params.filter);
    }

    //if object aggregate then stringify
    if (params.aggregate) {
      params.aggregate = typeof params.aggregate === 'string' ? params.aggregate : JSON.stringify(params.aggregate);
    }

    try {
      const authHeaders = this.getAuthHeaders();
      const requestOptions: {
        params: any;
        withCredentials: boolean;
        headers: any;
        context?: HttpContext;
      } = {
        params: this.removeUndefinedParams(params),
        withCredentials: true,
        headers: authHeaders,
      };
      if (suppressErrorToast) {
        requestOptions.context = new HttpContext().set(SILENT_HTTP_ERROR, true);
      }
      const data = await this.http.get<any>(urlendpoint, requestOptions).toPromise();



      // Save data in cachedData
      // this.storage_set(cacheKey, data);

      return data;
    } catch (error) {
      // Handle HTTP request errors here
      console.error(error);
      throw error; // Re-throw the error for the caller to handle if needed
    }
  }

  public save<T>(
    collection: string,
    payload: any
  ): Observable<T> {
    let isEdit = payload && payload['id']; // Check if it's an edit (has an 'id')
    let isMultiple = false;
    //if its array and has id then its edit
    if (Array.isArray(payload) && payload[0] && payload[0]['id']) {
      isEdit = true;
      isMultiple = true;
    } else if (Array.isArray(payload)) {
      isEdit = false;
      isMultiple = true;
    }


    //compare payload and item and remove the same properties which are not changed
    //if item is undefined then it is a new item so no need to remove properties

    //add tenant
    // payload.app= idata.app.id;
    console.log('save', payload);
    const save$ = isEdit
      ? this.http.patch<T>(
        `${this.portal_url}/items/${collection}/` + (isMultiple ? '' : payload['id']),
        payload
      )
      : this.http.post<T>(`${this.portal_url}/items/${collection}`, payload, { withCredentials: true });

    // Invalidate cache for the collection
    // this.invalidateCache(collection, params);
    //this.storage_clear(collection);

    return save$;
  }

  delete(collection: string, itemId: any, params?: any): Observable<void> {
    // Logic for deleting an item from the collection
    // You may want to handle the HTTP DELETE request here

    return this.http.delete<void>(`${this.portal_url}/items/${collection}/${itemId}`).pipe(
      catchError((err) => {
        console.error(err);
        return of(undefined);
      })
    );

    // Invalidate cache for the collection
    //this.invalidateCache(collection, params);

    return of(undefined); // Return nothing (for demonstration purposes)
  }
  /**
   * POST directly to any portal endpoint (not /items/).
   * Used for Directus built-in endpoints like /users, /roles etc.
   */
  async postDirect(endpoint: string, payload: any): Promise<any> {
    console.log('[ApiService] postDirect', endpoint, payload);
    const url = `${this.portal_url.replace(/\/+$/, '')}/${endpoint.replace(/^\/+/, '')}`;
    try {
      const res = await this.http.post<any>(url, payload, {
        withCredentials: true,
        headers: this.getAuthHeaders()
      }).toPromise();
      return res;
    } catch (error) {

      console.error('[ApiService] postDirect error', error);
      throw error;
    }
  }

  private getAuthHeaders(): any {
    const token = this.access_token || localStorage.getItem('access_token') || '';

    if (token) {
      return {
        Authorization: `Bearer ${token}`
      };
    }

    return {};
  }

  async patchDirect(endpoint: string, payload: any): Promise<any> {
    console.log('[ApiService] patchDirect', endpoint, payload);
    const url = `${this.portal_url.replace(/\/+$/, '')}/${endpoint.replace(/^\/+/, '')}`;
    try {
      const res = await this.http.patch<any>(url, payload, {
        withCredentials: true,
        headers: this.getAuthHeaders()
      }).toPromise();
      return res;
    } catch (error) {

      console.error('[ApiService] patchDirect error', error);
      throw error;
    }
  }

  async getUserActivity(userId: string): Promise<any[]> {
    try {
      const res = await this.get(`my-api/user-activity/${userId}`);
      return res?.data ?? res ?? [];
    } catch (error) {
      console.error('[ApiService] getUserActivity error', error);
      return [];
    }
  }

  private buildUrl(endpoint: string): string {
    return `${this.portal_url.replace(/\/+$/, '')}/${endpoint.replace(/^\/+/, '')}`;
  }
  /**
   * Switch Account — exchanges a session for a linked alias account's token.
   * Calls the custom backend endpoint /my-api/switch-account.
   */
  async switchAccount(aliasUserId: string): Promise<any> {
    const beforeUserId = this.current_user?.id || JSON.parse(localStorage.getItem('current_user') || 'null')?.id;
    console.log('[ApiService] switchAccount start', { aliasUserId, beforeUserId });
    const url = this.buildUrl('my-api/switch-account');

    try {
      const res = await this.http.post<any>(url, { alias_user_id: aliasUserId }, {
        withCredentials: true,
        headers: this.getAuthHeaders()
      }).toPromise();

      console.log('[ApiService] switchAccount response', {
        hasAccessToken: !!res?.access_token || !!(res as any)?.data?.access_token,
        hasRefreshToken: !!res?.refresh_token || !!(res as any)?.data?.refresh_token,
        responseUserId: res?.id ?? (res as any)?.data?.id,
        responseRole: res?.role ?? (res as any)?.data?.role
      });

      const accessToken = res?.access_token ?? (res as any)?.data?.access_token;
      const refreshTokenOut = res?.refresh_token ?? (res as any)?.data?.refresh_token;

      if (res && accessToken) {
        this.access_token = accessToken;
        localStorage.setItem('access_token', accessToken);

        // Persist the switched user ID so getSetAccessToken (localhost dev flow)
        // re-logs in as the correct user after the page reload

        sessionStorage.setItem('access_user_id', aliasUserId);

        // SIMR: remember which linked account must stay active after F5 / auth/refresh
        sessionStorage.setItem('simr_intended_user_id', aliasUserId);

        if (refreshTokenOut) {
          localStorage.setItem('refresh_token', refreshTokenOut);
        }

        // Update local profile
        const currentUserRes = await this.getSetCurrentUser().toPromise();
        const resolvedUserId = currentUserRes?.data?.id;
        console.log('[ApiService] switchAccount user refreshed', {
          aliasUserId,
          resolvedUserId,
          matchesRequestedUser: resolvedUserId === aliasUserId
        });
      }

      return res;
    } catch (error) {
      console.error('[ApiService] switchAccount error', {
        status: (error as any)?.status,
        message: (error as any)?.message,
        error: (error as any)?.error
      });
      throw error;
    }
  }

  /**
   * Fetch all alias accounts linked to the current primary user.
   * Uses parent_id from the current user.
   */
  async getLinkedAccounts(): Promise<any[]> {
    console.log('[ApiService] getLinkedAccounts');
    try {
      const res = await this.get('my-api/my-linked-accounts');
      console.log('[ApiService] getLinkedAccounts result', res?.data);
      return res?.data ?? [];
    } catch (e) {
      console.error('[ApiService] getLinkedAccounts error', e);
      return [];
    }
  }
  // src/app/services/api.service.ts

  getTracks(params: any) {
    // This uses the Directus items endpoint for the 'tracks' collection
    return this.http.get(`${this.portal_url}/items/tracks`, { params });
  }

  present_alert(heading: string, msg: string = '') {

    //replace new line with <br>
    msg = msg.replace(/\n/g, '<br>');

    let alert: any = this.alertController.create({
      header: heading,
      message: msg,
      buttons: ['OK'],
    });
    alert.then((alert: { present: () => any }) => alert.present());
  }

  async present_toast(type: any, header: any, msg = '', options: any = {}) {
    let color = 'primary';
    //console.log(type);
    switch (type) {
      case 'success':
        color = 'success';
        break;

      case 'info':
        color = 'success';
        break;

      case 'error':
        color = 'danger';
        break;

      default:
        color = 'primary';
    }
    const toastConfig: any = {
      header: header,
      message: msg ?? '',
      duration: options.duation ?? 3000,
      color: color,
      position: 'top',
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          },
        },
      ],
    };
    if (options.cssClass) toastConfig.cssClass = options.cssClass;
    const toast = await this.toastController.create(toastConfig);
    await toast.present();
  }

  // inside ApiService class
  public async getRaw(url: string, params: any = {}): Promise<any> {
    try {
      const data = await this.http.get<any>(url, {
        params: this.removeUndefinedParams(params),
        withCredentials: true,
      }).toPromise(); // or use firstValueFrom in Angular 15+

      return data;
    } catch (error) {
      console.error('getRaw error:', error);
      throw error;
    }
  }
  private removeUndefinedParams(params: any): HttpParams {
    let cleanedParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] !== undefined) {
        cleanedParams = cleanedParams.append(key, params[key]);
      }
    }
    return cleanedParams;
  }

  removeNonChangedProperties(payload: any, item: any) {
    payload = this.cloneWR(payload);
    item = this.cloneWR(item);
    //compare payload and item and remove the same properties which are not changed
    for (const key in payload) {
      if (payload.hasOwnProperty(key) && payload[key] === item[key]) {
        delete payload[key];
      }
    }

    //add id if in payload OR item
    if (payload['id']) {
      payload['id'] = item['id'];
    } else if (item['id']) {
      payload['id'] = item['id'];
    }

    return payload;
  }

  getPlainNameString(s: any) {
    return s.toLowerCase().replace(/\s/g, '');
  }

  cloneWR(p: any) {
    return p ? JSON.parse(JSON.stringify(p)) : '';
  }

  upload(file: File, name = 'file', params: any = {}, signal?: AbortSignal): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    // Only send width/height when set — empty strings cause MySQL
    // ER_TRUNCATED_WRONG_VALUE_FOR_FIELD on directus_files.width/height.
    if (params?.width !== undefined && params?.width !== null && String(params.width) !== '') {
      formData.append('width', String(params.width));
    }
    if (params?.height !== undefined && params?.height !== null && String(params.height) !== '') {
      formData.append('height', String(params.height));
    }
    // Use the real filename so Directus stores filename_download correctly.
    formData.append('file', file, file?.name || name);

    let req = new HttpRequest('POST', `${this.portal_upload_url}/files`, formData, {
      reportProgress: true,

      responseType: 'json'

    });

    if (signal) {
      (req as any).signal = signal;
    }

    return this.http.request(req);
  }


  private refreshInFlight: Observable<any> | null = null;

  refresh_token(silent = false) {
    if (this.refreshInFlight) return this.refreshInFlight;
    const refreshToken = (localStorage.getItem('refresh_token') || '').trim();
    const body = refreshToken ? { refresh_token: refreshToken } : {};
    const options: { withCredentials: boolean; context?: HttpContext } = { withCredentials: true };
    if (silent) options.context = new HttpContext().set(SILENT_HTTP_ERROR, true);
    this.refreshInFlight = this.http.post<any>(this.buildUrl('auth/refresh'), body, options).pipe(
      map((res) => {
        const data = res?.data ?? res;
        if (data?.access_token) {
          console.log('refreshed token', data.access_token);
          this.access_token = data.access_token;
          localStorage.setItem('access_token', data.access_token);
          if (data.refresh_token) {
            localStorage.setItem('refresh_token', data.refresh_token);
          }
          this.getSetCurrentUser().subscribe(() => {});
        }
        return res;
      }),
      finalize(() => {
        this.refreshInFlight = null;
      }),
      shareReplay(1)
    );
    return this.refreshInFlight;
  }
  getProductById(id: string) {
    const baseUrl = this.portal_url.endsWith('/')
      ? this.portal_url
      : this.portal_url + '/';

    // ✅ ADD THIS LINE HERE
    // console.log('API URL →', `${baseUrl}items/products/${id}`);

    return this.http.get(
      `${baseUrl}items/products/${id}?fields=*,tracks.tracks_id.*`
    );
  }

  getSetCurrentUser() {
    // return this.http.get<any>(this.portal_url+'/users/me', {params:{fields:'id,first_name,email,role.*'},withCredentials:true}).pipe(
    return this.http.get<any>(this.portal_url + '/users/me', {
      params: { fields: '*,role.*' },
      withCredentials: true,
      headers: this.getAuthHeaders()
    }).pipe(

      map((res) => {
        console.log('[ApiService] getSetCurrentUser resolved', {
          id: res?.data?.id,
          email: res?.data?.email,
          role: res?.data?.role?.name || res?.data?.role,
          hasAccessToken: !!(this.access_token || localStorage.getItem('access_token'))
        });
        if (res && res?.data) {
          localStorage.setItem('role_detail', JSON.stringify(res.data.role));
          localStorage.setItem('current_user', JSON.stringify(res.data));
          this.current_user = res.data;
          // Role-wise permission change
          // this.currentRole = res.data.role || {};
          // this.currentPermissions = this.currentRole;
          this.syncRoleDerivedStateFromCurrentUser(res.data);

          this.currentUser$.next(res.data);
        }
        return res;
      })
    );
  }

  private accessUserLoginTask: Promise<any> | null = null;
  private accessUserLoginId = '';

  /** A Directus JWT past `exp`. Static custom-login tokens are not JWTs and stay as they are. */
  accessTokenExpired(): boolean {
    const token = String(localStorage.getItem('access_token') || this.access_token || '');
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    try {
      let encoded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      encoded += '='.repeat((4 - (encoded.length % 4)) % 4);
      const json = atob(encoded);
      const exp = Number(JSON.parse(json)?.exp);
      if (!Number.isFinite(exp)) return false;
      return exp * 1000 <= Date.now();
    } catch {
      return false;
    }
  }

  /** One custom-login for a portal user id. The route guard and app startup share this. */
  ensureAccessUserLogin(userId: string): Promise<any> {
    const existingToken = localStorage.getItem('access_token');
    if (existingToken && this.accessUserLoginId === userId) {
      return Promise.resolve({ access_token: existingToken });
    }
    if (this.accessUserLoginTask && this.accessUserLoginId === userId) {
      return this.accessUserLoginTask;
    }
    this.accessUserLoginId = userId;
    this.accessUserLoginTask = new Promise((resolve, reject) => {
      this.auth('login', { user_idstring: userId }).subscribe({
        next: (res) => {
          if (!res?.access_token) {
            resolve(res);
            return;
          }
          // The product page and role list both need the saved profile.
          // custom-login returns before /users/me finishes.
          let settled = false;
          const finish = () => {
            if (settled) return;
            settled = true;
            resolve(res);
          };
          const timeout = setTimeout(finish, 8000);
          const sub = this.currentUser$.subscribe((user) => {
            if (!user) return;
            clearTimeout(timeout);
            sub.unsubscribe();
            finish();
          });
        },
        error: (err) => reject(err),
      });
    }).finally(() => {
      this.accessUserLoginTask = null;
    });
    return this.accessUserLoginTask;
  }

  auth(action: any = 'login', payload: any = {}, provider: any = '') {
    //send POST request
    return this.http.post<any>(this.portal_url + '/my-api/custom-login', payload).pipe(
      map((res) => {
        console.log(res);
        if (res && res.access_token) {
          onSimrLoginPrimaryUser(null);
          this.access_token = res.access_token;
          this.current_user = res.user;
          // Role-wise permission change
          // this.currentRole = res.user?.role || {};
          // this.currentPermissions = this.currentRole;
          // this.syncRoleDerivedStateFromCurrentUser(res.user || {});
          const loginUser = res.user || {};
          if (!loginUser.role && Array.isArray(res.role) && res.role[0]) {
            loginUser.role = res.role[0];
          }
          this.syncRoleDerivedStateFromCurrentUser(loginUser);
          localStorage.setItem('access_token', res.access_token);
          if (res.refresh_token) {
            localStorage.setItem('refresh_token', res.refresh_token);
          }
          // localStorage.setItem('current_user',res.user);


          //              localStorage.setItem('role_detail',JSON.stringify(res.role[0]));
          this.getSetCurrentUser().subscribe(res => {
            console.log('called c current user local');
          });
        }
        return res;
      })
    );

  }

  get_cdn_url(id: any, params: any = {}, src = 'portal') {
    let url = this.portal_url + '/assets/' + id + '/' + id + '.jpg';
    if (src == 'matrix') {
      url = this.matrix_url + '/assets/' + id + '/' + id + '.jpg';
    }


    if (params) {
      url += '?' + this.serialize(params);
    }
    return url;
  }

  /**
   * Original Directus file URL (PDF, Excel, audio, etc.).
   * Do not use get_cdn_url for non-images — that helper always appends .jpg and
   * Directus then serves/transforms the file as JPEG.
   */
  get_file_url(id: any, filename?: string) {
    if (!id) return '';
    const base = `${this.portal_url}/assets/${id}`;
    const name = String(filename || '').replace(/[/\\]/g, '_').trim();
    if (!name) return base;
    return `${base}/${encodeURIComponent(name)}`;
  }
  serialize(obj: any) {
    var str: any = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(p + '=' + obj[p]);
      }
    return str.join('&');
  }

  logout() {
    console.log('[ApiService] logout initiated');
    const refreshToken = localStorage.getItem('refresh_token');
    const accessToken = this.access_token || localStorage.getItem('access_token');

    const logoutUrl = this.buildUrl('auth/logout');

    // We send the logout request with current credentials before clearing them
    this.http.post(logoutUrl, { refresh_token: refreshToken }, {
      withCredentials: true,
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {}
    }).subscribe({
      next: () => {
        console.log('[ApiService] logout successful');
        this.storage_clear();
        window.location.href = '/login';
      },
      error: (err) => {
        console.error('[ApiService] logout error', err);
        this.storage_clear();
        window.location.href = '/login';
      }
    });
  }

  storage_clear() {
    console.log('[ApiService] storage_clear: Cleaning up all session data');

    const keysToRemove = [
      'access_token',
      'refresh_token',
      'current_user',
      'role_detail',
      'active_role',
      'access_user_id',
      'simr_intended_user_id',
      'role_selection_handled'
    ];

    keysToRemove.forEach(key => localStorage.removeItem(key));

    // Clear all sessionStorage
    sessionStorage.clear();

    this.access_token = '';
    this.current_user = null;
    // Role-wise permission change
    // (no explicit reset previously)
    this.currentRole = {};
    this.currentPermissions = {};
    this.currentUser$.next(null);
    console.log('[ApiService] storage_clear: Complete');
  }


  async presentAlertConfirm(header: any, message: any, ok: any = 'OK', cancel: any = 'Cancel', cssClass?: string) {
    //create alert controller and return yes for true and false for no

    return new Promise((resolve) => {
      const alert = this.alertController.create({
        header: header,
        message: message,
        backdropDismiss: false,
        cssClass: cssClass,
        buttons: [

          {
            text: ok,
            handler: () => {
              resolve(false);
            },
          },
          {
            text: cancel,
            role: 'cancel',
            handler: () => {
              resolve(true);
            },
          },
        ],
      });
      alert.then((alert: { present: () => any }) => alert.present());
    });
  }

  close_modal(data: any = {}) {
    this.modalController.dismiss(data);
  }

  m2mModelFix(field: any = '', data: any = []) {
    let rdata: any = [];
    data.forEach(element => {
      let pf: any = element[field + '_id'];
      if (!pf) return;
      pf.junction_id = element.id; // Store junction ID separately
      //special fields handling 
      switch (field) {
        case 'tracks':
          pf.track_delivery_status = element.track_delivery_status;
          pf.available_partners = element.available_partners;
          pf.available_partners_meta = element.available_partners_meta;
          pf.delivery_date = element.delivery_date;
          // Junction sequence (products_tracks.sort). Kept off the track record,
          // which has its own unrelated sort column.
          pf.junction_sort = element.sort != null && element.sort !== '' ? Number(element.sort) : null;
          break;
      }
      rdata.push(pf);
    });
    //console.log(field,data,rdata);
    return rdata;
  }

  m2mRefurnModelFix(field: any = '', data: any = []) {
    let rdata: any = [];
    data.forEach(element => {
      if (element) {
        let junctionRecord: any = { [field + '_id']: element };
        if (element.junction_id) {
          junctionRecord.id = element.junction_id;
        }
        // Preserve junction-level fields
        if (element.available_partners) junctionRecord.available_partners = element.available_partners;
        if (element.available_partners_meta) junctionRecord.available_partners_meta = element.available_partners_meta;
        if (element.delivery_date) junctionRecord.delivery_date = element.delivery_date;
        if (element.junction_sort != null && element.junction_sort !== '') {
          junctionRecord.sort = Number(element.junction_sort);
        }

        const related = junctionRecord[field + '_id'];
        if (related && typeof related === 'object') {
          delete related.junction_sort;
          delete related.junction_id;
          delete related.index;
        }

        rdata.push(junctionRecord);
      }
    });
    //console.log(field,data,rdata);
    return rdata;
  }
  // setSelectedActivity(activity: any) {
  //   this.selectedActivity = activity; // Store the selected activity
  // }

  // getSelectedActivity(): any {
  //   return this.selectedActivity; // Retrieve the stored activity
  // }
}